import React, { useState, useEffect, useRef } from "react";
import ImageEditor from '@toast-ui/react-image-editor';
import Loading from "../Pages/Signup/Loading";
import Spinner from "../Common/Spinner";
import 'tui-image-editor/dist/tui-image-editor.css';
import "./index.css";

import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

var $ = window.$;

const FileEditor = ({
  file,
  sendEditedFile = () => {},
  modalClose = () => {},
}) => {
  const [url, setUrl] = useState(file.attachments[0].file.url);

  const editorRef = useRef(null);
  const canvasRef = useRef(null);
  const overlayRef = useRef(null);
  const containerRef = useRef(null);
  const inputRef = useRef(null); // text input
  const willDrawing = useRef(false);
  const currentStroke = useRef([]); // Current drawing path

  const [pdfBytes, setPdfBytes] = useState(null);
  const [highlights, setHighlights] = useState([]); // 
  const [annotations, setAnnotations] = useState([]); // check
  const [penStrokes, setPenStrokes] = useState([]); // All pen drawings

  const [highlightsByPage, setHighlightsByPage] = useState({}); // Highligh per page
  const [textByPage, setTextByPage] = useState({}); // Text per page
  const [penByPage, setPenByPage] = useState({}); // Pen per page

  const [isDrawing, setIsDrawing] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(1.5);
  const [highlightColor, setHighlightColor] = useState("#ffbb3b");
  const [inputData, setInputData] = useState(null); // { x, y, value } dynamic text-input


  const [pdf, setPdf] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [hasEdit, sethasEdit] = useState(false); //
  const [activeEdit, setActiveEdit] = useState(null);
  const [isPdf, setisPdf] = useState(false);
  const [redoEdit, setRedoEdit] = useState([]);
  const [drawHistory, setDrawHistory] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const [penMode, setPenMode] = useState(false); // Toggle on/off if needed

  const editorHeight = window.innerHeight - 250;
  const colorPalette = [
    "#000000",
    "#7e7e7e",
    "#ff4040",
    "#ff6518",
    "#ffbb3b",
    "#03bd9e",
    "#00a9ff",
    "#515ce6",
    "#9e5fff",
    "#ff5583"];

  useEffect(() => {
    setIsloading(true);
    const extension = url.split('.').pop().split(/\#|\?/)[0];

    if (extension === "pdf") {
      setisPdf(true);

      const loadPDF = async () => {
        try {
          const response = await fetch(url);
          const arrayBuffer = await response.arrayBuffer();
          setPdfBytes(arrayBuffer);

          const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
          const loadedPdf = await loadingTask.promise;

          setPdf(loadedPdf);
          setTotalPages(loadedPdf.numPages);

          renderPage(loadedPdf, pageNum);
          setIsloading(false);
        } catch (err) {
          console.error("Failed to load PDF:", err);
          setIsloading(false);
        }
      };
      loadPDF();
    } else {
      const editorInstance = editorRef.current.getInstance();
      if (!editorInstance) return;

      const bustCache = (url) => {
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}_=${Date.now()}`;
      };

      const bustedUrl = bustCache(url);

      editorInstance
        .loadImageFromURL(bustedUrl, 'MyImage')
        .then(() => {
          editorInstance.clearUndoStack();
          editorInstance.ui.resizeEditor();
          editorInstance.ui.activeMenuEvent();

          setTimeout(() => {
            editorInstance.ui.changeMenu('draw');
          }, 100);
          setIsloading(false);
        })
        .catch((err) => {
          console.error('Image load failed', err);
          setIsloading(false);
        });
    }
  }, [url]);

  const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, '');      
    if (hex.length === 3) {
      hex = hex.split('').map(char => char + char).join('');
    }
    const r = parseInt(hex.slice(0, 2), 16) / 255;
    const g = parseInt(hex.slice(2, 4), 16) / 255;
    const b = parseInt(hex.slice(4, 6), 16) / 255;

    return rgb(r, g, b); // Use pdf-lib's rgb() helper
  }

  //update this
  // useEffect(() => {
  //   if (highlights.length > 0 || textAnnotations.length > 0) {
  //     sethasEdit(true)
  //   } else {
  //     sethasEdit(false);
  //   }
  // }, [highlights, textAnnotations]);

  const handleDownload = () => {
    setIsloading(true);
    if (isPdf) {
      downloadPdfEdited();
    } else {
      downloadImageEdited();
    }
  }

  const downloadImageEdited = () => {
    const editorInstance = editorRef.current.getInstance();
    const imageDataUrl = editorInstance.toDataURL();
    const link = document.createElement("a");
    link.href = imageDataUrl;

    const pathname = new URL(url).pathname;
    const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
    const extension = url.split('.').pop().split(/\#|\?/)[0];

    const date = new Date();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const fileName = `_edited${mm}${dd}${yy}.` + extension;

    link.download = filename.split('.')[0] + fileName;
    link.click();
    setTimeout(() => setIsloading(false), 1000);
  };

  const downloadPdfEdited = async () => {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    pdfDoc.getPages().forEach((page, index) => {
      const pageNumber = index + 1;
      const pageHeight = page.getHeight();

      // Draw highlights
      (highlightsByPage[pageNumber] || []).forEach((rect) => {
        const x = rect.x / scale;
        const y = rect.y / scale;
        const width = rect.width / scale;
        const height = rect.height / scale;
        const yPDF = pageHeight - y - height;

        page.drawRectangle({
          x,
          y: yPDF,
          width,
          height,
          color: rgbaToRgb(rect.color),
          opacity: 0.4,
        });
      });

      // Draw texts
      (textByPage[pageNumber] || []).forEach((ta) => {
        const x = ta.x / scale;
        const yPDF = pageHeight - ta.y / scale - 9; // adjust
        
        page.drawText(ta.value, {
          x,
          y: yPDF,
          size: 16, // fixed font-size
          font,
          color: rgb(0, 0, 0),
        });
      });
//
      // Draw Pen Strokes
      const penStrokes = penByPage[index + 1] || [];
      penStrokes.forEach((stroke) => {
        for (let j = 1; j < stroke.points.length; j++) {
          const prev = stroke.points[j - 1];
          const curr = stroke.points[j];

          const x1 = prev.x / scale;
          const y1 = pageHeight - prev.y / scale;
          const x2 = curr.x / scale;
          const y2 = pageHeight - curr.y / scale;

          page.drawLine({
            start: { x: x1, y: y1 },
            end: { x: x2, y: y2 },
            color: hexToRgb(stroke.color),
            thickness: 1.5,
          });
        }
      });
    });

    const pathname = new URL(url).pathname;
    const name = pathname.substring(pathname.lastIndexOf('/') + 1);

    const date = new Date();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const fileName = name + `_edited${mm}${dd}${yy}.pdf`;

    const pdfBytesNew = await pdfDoc.save();
    const blob = new Blob([pdfBytesNew], { type: 'application/pdf' });
    const url_obj = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url_obj;
    link.download = fileName;
    link.click();
    setTimeout(() => setIsloading(false), 1000);
  };

  // Send Edited File

  const handleSendEdit = () => {
    setIsloading(true);
    if (isPdf) {
      sendEditedPdf();
    } else {
      sendEditedImage();
    }
  }

  const sendEditedImage = () => {
    setIsloading(true);
    const editorInstance = editorRef.current.getInstance();
    const imageDataUrl = editorInstance.toDataURL();
    const mimeType = imageDataUrl.split(';')[0].split(':')[1];
    const extension = mimeType.split('/')[1];

    const date = new Date();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const fileName = `_edited${mm}${dd}${yy}.` + extension;

    const blob = dataURLtoBlob(imageDataUrl);
    const file = new File([blob], fileName, { type: blob.type });//
    setTimeout(() => {
      setIsloading(false);
      sendEditedFile(file);
    }, 1000);
  }

  const sendEditedPdf = async () => {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    pdfDoc.getPages().forEach((page, index) => {
      const pageNumber = index + 1;
      const pageHeight = page.getHeight();

      // Draw highlights
      (highlightsByPage[pageNumber] || []).forEach((rect) => {
        const x = rect.x / scale;
        const y = rect.y / scale;
        const width = rect.width / scale;
        const height = rect.height / scale;
        const yPDF = pageHeight - y - height;

        page.drawRectangle({
          x,
          y: yPDF,
          width,
          height,
          color: rgbaToRgb(rect.color),
          opacity: 0.4,
        });
      });

      // Draw texts
      (textByPage[pageNumber] || []).forEach((ta) => {
        const x = ta.x / scale;
        const yPDF = pageHeight - ta.y / scale - 9; // adjust
        
        page.drawText(ta.value, {
          x,
          y: yPDF,
          size: 16, // fixed font-size
          font,
          color: rgb(0, 0, 0),
        });
      });

      // Draw Pen Strokes
      const penStrokes = penByPage[index + 1] || [];
      penStrokes.forEach((stroke) => {
        for (let j = 1; j < stroke.points.length; j++) {
          const prev = stroke.points[j - 1];
          const curr = stroke.points[j];

          const x1 = prev.x / scale;
          const y1 = pageHeight - prev.y / scale;
          const x2 = curr.x / scale;
          const y2 = pageHeight - curr.y / scale;

          page.drawLine({
            start: { x: x1, y: y1 },
            end: { x: x2, y: y2 },
            color: hexToRgb(stroke.color),
            thickness: 1.5,
          });
        }
      });
    });

    const date = new Date();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const fileName = `_edited${mm}${dd}${yy}.pdf`;

    const pdfBytesNew = await pdfDoc.save();
    const blob = new Blob([pdfBytesNew], { type: 'application/pdf' });
    const file = new File([blob], fileName, { type: blob.type });

    setTimeout(() => {
      setIsloading(false);
      sendEditedFile(file);
    }, 1000);
  }

  const dataURLtoBlob = (dataUrl) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  
  const customTheme = {
    'common.fontFamily': 'Arial, sans-serif',
  };

  // REDO & UNDO function

  const handleRedoEdit = () => {
    setRedoEdit((prev) => {
      if (prev.length === 0) return prev;

      const current = [...prev];
      const first = current.pop();;
      const page = first.page;

      setDrawHistory((prev) => [...prev, first]);

      if (first.type === 'highlight') {
        if (page === pageNum) {
          setHighlights((prev) => {
            const updated = [...prev, first.data];
            setTimeout(() => redrawHighlights(updated, annotations, penStrokes), 0);
            return updated;
          });
        }
        setHighlightsByPage((prev) => ({
          ...prev,
          [page]: [...(prev[page] || []), first.data],
        }));

      } else if (first.type === 'text') {
        if (page === pageNum) {
          setAnnotations((prev) => {
            const updated = [...prev, first.data];
            setTimeout(() => redrawHighlights(highlights, updated, penStrokes), 0);
            return updated;
          });
        }
        setTextByPage((prev) => ({
          ...prev,
          [page]: [...(prev[page] || []), first.data],
        }));
        
      } else if (first.type === 'pen') {
        if (page === pageNum) {
          setPenStrokes((prev) => {
            const updated = [...prev, first.data];
            setTimeout(() => redrawHighlights(highlights, annotations, updated), 0);
            return updated;
          });
        }
        //
        setPenByPage((prev) => ({
          ...prev,
          [page]: [...(prev[page] || []), first.data],
        }));
        
      }
      return prev.slice(0, -1);
    });
  }

  const handleUndoEdit = () => {
    setDrawHistory((prev) => {
      if (prev.length === 0) return prev;

      const updated = [...prev];
      const last = updated.pop();

      setRedoEdit((prev) => [...prev, last]);

      if (last.type === 'highlight') {        
        if (last.page === pageNum) {
          setHighlights((prev) => {
            const updated = prev.slice(0, -1);
            setTimeout(() => redrawHighlights(updated, annotations, penStrokes), 0);
            return updated;
          });
        }
        setHighlightsByPage((prev) => ({
          ...prev,
          [last.page]: (prev[last.page] || []).filter(
            (h) => h !== last.data
          ),
        }));

      } else if (last.type === 'text') {
        if (last.page === pageNum) {
          setAnnotations((prev) => prev.slice(0, -1));
        }       

        setTextByPage((prev) => ({
          ...prev,
          [last.page]: (prev[last.page] || []).filter(
            (t) => t !== last.data
          ),
        }));
      } else if (last.type === 'pen') {
        if (last.page === pageNum) {
          setPenStrokes((prev) => {
            const updated = prev.slice(0, -1);
            setTimeout(() => redrawHighlights(highlights, annotations, updated), 0);
            return updated;
          })
        }
        setPenByPage(prev => {
          const updatedPageData = [...(prev[last.page] || [])];
          updatedPageData.splice(-1, 1);

          return {
            ...prev,
            [last.page]: updatedPageData,
          };
        });
      }

      return prev.slice(0, -1);
    });
  };

  const renderPage = async (pdfDoc, pageNum) => {
    const page = await pdfDoc.getPage(pageNum);

    const container = containerRef.current;
    const containerHeight = container.clientHeight;

    const viewport = page.getViewport({ scale: 1 });
    const scale = containerHeight / viewport.height; // Scale to fit height
    const scaledViewport = page.getViewport({ scale });

    const canvas = canvasRef.current;
    const overlay = overlayRef.current;
    const context = canvas.getContext("2d");

    // Resize canvas
    canvas.width = scaledViewport.width;
    canvas.height = scaledViewport.height;
    overlay.width = scaledViewport.width;
    overlay.height = scaledViewport.height;

    // Apply styles so canvas scales visually as well
    canvas.style.width = `${scaledViewport.width}px`;
    canvas.style.height = `${scaledViewport.height}px`;
    overlay.style.width = `${scaledViewport.width}px`;
    overlay.style.height = `${scaledViewport.height}px`;

    // Render the PDF
    const renderContext = {
      canvasContext: context,
      viewport: scaledViewport,
    };

    await page.render(renderContext).promise;
    setScale(scale);
  };

  const goToPage = async (offset) => {
    const newPage = pageNum + offset;
    if (newPage >= 1 && newPage <= totalPages) {
      setPageNum(newPage);

      await renderPage(pdf, newPage);

      const pageHighlights = highlightsByPage[newPage] || [];
      const pageTexts = textByPage[newPage] || [];
      const penStrokes = penByPage[newPage] || [];

      setHighlights(pageHighlights);
      setAnnotations(pageTexts);
      setPenStrokes(penStrokes);

      redrawHighlights(pageHighlights, pageTexts, penStrokes);
    }
  };

  const redrawHighlights = (
      highlightList = highlights,
      textList = annotations,
      penStrokesList = penStrokes
    ) => {
    const overlay = overlayRef.current;
    const ctx = overlay.getContext('2d');
    ctx.clearRect(0, 0, overlay.width, overlay.height);

    // Draw highlights
    highlightList.forEach((rect) => {
      ctx.fillStyle = rect.color || 'rgba(255, 255, 0, 0.4)';
      ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
    });

    // Redraw pen strokes
    penStrokesList.forEach((stroke) => {
      if (!stroke || stroke.points.length === 0) return;
      ctx.beginPath();
      ctx.moveTo(stroke.points[0].x, stroke.points[0].y);
      for (let i = 1; i < stroke.points.length; i++) {
        ctx.lineTo(stroke.points[i].x, stroke.points[i].y);
      }
      ctx.strokeStyle = stroke.color;
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.stroke();
      ctx.closePath();
    });
  };

  // Highlight draw

  const handleMouseDown = (e) => {
    if (activeEdit != "highlight") return;
    setIsDrawing(true);
    const rect = overlayRef.current.getBoundingClientRect();
    setStartPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  function hexToRgba(hex, alpha = 0.3) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const handleMouseMove = (e) => {
    if (activeEdit != "highlight") return;
    if (!isDrawing) return;
    const overlay = overlayRef.current;
    const ctx = overlay.getContext('2d');
    const rect = overlay.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const width = mouseX - startPos.x;
    const height = mouseY - startPos.y;

    redrawHighlights(); // Redraw previous
    ctx.fillStyle = hexToRgba(highlightColor, 0.3);
    ctx.fillRect(startPos.x, startPos.y, width, height);
  };

  const handleMouseUp = (e) => {
    if (activeEdit != "highlight") return;
    if (!isDrawing) return;
    setIsDrawing(false);

    const rect = overlayRef.current.getBoundingClientRect();
    const endX = e.clientX - rect.left;
    const endY = e.clientY - rect.top;
    const width = endX - startPos.x;
    const height = endY - startPos.y;

    const newRect = {
      x: startPos.x,
      y: startPos.y,
      width,
      height,
      color: hexToRgba(highlightColor, 0.3),
    };

    setHighlights((prev) => {
      const updated = [...prev, newRect];
      setTimeout(() => redrawHighlights(updated, annotations), 0);
      return updated;
    });
    setDrawHistory((prev) => {
      const arry = [...prev,
        {
          page: pageNum,
          type: 'highlight',
          data: newRect,
        },
      ];
      return arry;
    });
    setHighlightsByPage((prev) => ({
      ...prev,
      [pageNum]: [...(prev[pageNum] || []), newRect],
    }));
  };

  // Text draw

  const handleCanvasClick = (e) => {
    e.preventDefault();
    if (activeEdit != "text") return;
    if (isDrawing) return;

    const conRect = containerRef.current.getBoundingClientRect();
    const rect = overlayRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const drawX = e.clientX - conRect.left;
    const drawY = e.clientY - rect.top + 33; // adjust

    setInputData({ x, y, value: '', drawX, drawY });
  };

  const handleInputKeyDown = (e) => {
    if (activeEdit != "text") return;
    if (e.key === 'Enter' && inputData.value.trim()) {
      const newText = inputData;
      setAnnotations((prev) => {
        const update = [...prev, newText];
        return update;
      });
      setDrawHistory((prev) => {
        const arry = [...prev,
          {
            page: pageNum,
            type: 'text',
            data: newText,
          },
        ];
        return arry;
      });
      setTextByPage((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), newText],
      }));

      setInputData(null); // Remove input
    } else if (e.key === 'Escape') {
      setInputData(null); // Cancel
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputData]);

  const rgbaToRgb = (rgba) => {
    const [r, g, b] = rgba.match(/\d+/g).map((v) => parseInt(v) / 255);
    return rgb(r, g, b);
  };

  const handleClose = () => {
    if (false) { //hasEdit
      setOpenConfirm(true);
    } else {
      modalClose();
    }
  }

  // Pen drawing

  useEffect(() => {
    if (activeEdit != "pen") return;
    const canvas = overlayRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    const getMousePos = (e) => {
      const rect = canvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
    };

    const handleMouseDown = (e) => {
      if (!penMode) return;
      willDrawing.current = true;
      const { x, y } = getMousePos(e);

      ctx.beginPath();
      ctx.moveTo(x, y);

      currentStroke.current = [{ x, y }];
    };

    const handleMouseMove = (e) => {
      if (!penMode || !willDrawing.current) return;
      const { x, y } = getMousePos(e);

      ctx.lineTo(x, y);
      ctx.strokeStyle = highlightColor;
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.stroke();

      currentStroke.current.push({ x, y });
    };

    const handleMouseUp = () => {
      if (!penMode) return;
      willDrawing.current = false;
      ctx.closePath();

      if (currentStroke.current.length > 0) {
        setPenStrokes((prev) => [
          ...prev,
          {
            color: highlightColor,
            points: [...currentStroke.current],
          }
        ]);
        //
        setPenByPage((prev) => ({
            ...prev,
            [pageNum]: [...(prev[pageNum] || []),
              {
                color: highlightColor,
                points: [...currentStroke.current],
              }
            ],
        }));
        //
        setDrawHistory((prev) => {
          const arry = [...prev,
            {
              page: pageNum,
              type: 'pen',
              data: {
                color: highlightColor,
                points: [...currentStroke.current],
              },
            },
          ];
          return arry;
        });
        currentStroke.current = [];
      }
    };

    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseup', handleMouseUp);
    canvas.addEventListener('mouseleave', handleMouseUp);

    return () => {
      canvas.removeEventListener('mousedown', handleMouseDown);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseup', handleMouseUp);
      canvas.removeEventListener('mouseleave', handleMouseUp);
    };
  }, [penMode, activeEdit, pageNum, highlightColor]);

  return (
    <div
      // style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
      className="Image-Editor-Modal"
    >
      <div className="image-editor-action">
        <div className="export-action">
          <button
            className="File-Action-Button"
            // onClick={() => handleDownload()}
            onClick={() => handleDownload()}
            style={{ marginRight: "10px" }}
          >
            <i className="fas fa-download mr-2"></i>
            <span style={{ fontSize: "15px" }}>Download</span>
          </button>
          <button
            className="File-Action-Button"
            onClick={() => handleSendEdit()}
          >
            <i 
              className="fas fa-paper-plane"
              style={{ width: "22px", marginRight: "10px" }}
            ></i> 
            <span style={{ fontSize: "15px" }}>Send</span>
          </button>
        </div>
        {isPdf ? (
          <div className="editor-action">
            <button
              className="File-Action-Button"
              onClick={() => {
                setPenMode(true);
                setActiveEdit("pen");
              }}
              style={{
                marginRight: "10px",
                backgroundColor: activeEdit === "pen" ? "grey" : ""
              }}
              data-toggle="tooltip"
              data-placement="top"
              data-html="true"
              title="Draw"
            >
              <i className="fas fa-solid fa-pen fa-sm"></i>
            </button>
            <button
              className="File-Action-Button"
              onClick={() => {
                setPenMode(false);
                setActiveEdit("highlight");
              }}
              style={{
                marginRight: "10px",
                backgroundColor: activeEdit === "highlight" ? "grey" : ""
              }}
              data-toggle="tooltip"
              data-placement="top"
              data-html="true"
              title="Highlight"
            >
              <i className="fas fa-solid fa-paint-roller fa-sm"></i>
            </button>
            <button
              className="File-Action-Button"
              onClick={() => {
                setPenMode(false);
                setActiveEdit("text");
              }}
              style={{
                marginRight: "10px",
                backgroundColor: activeEdit === "text" ? "grey" : ""
              }}
              data-toggle="tooltip"
              data-placement="top"
              data-html="true"
              title="Text"
            >
              <span style={{ fontSize: "25px", fontFamily: "'Times New Roman', Times, serif" }}>
                T
              </span>
            </button>
            <div className="dropup">
              <button
                type="button"
                className="File-Action-Button"
                id="dropdownColorPicker"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{
                  margin: "8px",
                  background: highlightColor,
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                }}
                data-placement="top"
                data-html="true"
                title="Color"
              >
              </button>
              <div
                className="dropdown-menu dropdown-color-picker"
                aria-labelledby="dropdownColorPicker"
              >
                <div className="color-palette-picker">
                  {colorPalette.map((color, index) => (
                    <a 
                      id={index}
                      href="#!"
                      style={{ background: color }}
                      onClick={() => setHighlightColor(color)}
                    >
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <button
              className="File-Action-Button"
              onClick={() => handleUndoEdit()}
              data-toggle="tooltip"
              data-placement="top"
              data-html="true"
              title="Undo"
            >
              <i 
                className="fas fa-reply"
                style={{ width: "22px", marginRight: "10px" }}
              ></i> 
            </button>
            <button
              className="File-Action-Button"
              onClick={() => handleRedoEdit()}
              data-toggle="tooltip"
              data-placement="top"
              data-html="true"
              title="Redo"
            >
              <i 
                className="fas fa-share"
                style={{ width: "22px", marginRight: "10px" }}
              ></i> 
            </button>
            <div className="pagination-action">
              <button
                className="page-button"
                onClick={() => goToPage(-1)}
                disabled={pageNum <= 1}
                data-toggle="tooltip"
                data-placement="top"
                data-html="true"
                title="Prev page"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              <label>
                Page {pageNum} of {totalPages}
              </label>
              <button
                className="page-button"
                onClick={() => goToPage(1)}
                disabled={pageNum >= totalPages}
                data-toggle="tooltip"
                data-placement="top"
                data-html="true"
                title="Next page"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div>
          <button
            className="File-Action-Button"
            onClick={() => handleClose()}
            style={{ width: "32px" }}
            // data-toggle="tooltip"
            // data-placement="top"
            // data-html="true"
            // title="Close"
          >
            <i className="fal fa-times fa-lg" style={{ color: "#dcdcdc" }} />
          </button>
        </div>
      </div>
      {!isPdf ? (
        // Image Editor
        <div>
          <ImageEditor
            ref={editorRef}
            includeUI={{
              // loadImage: {
              //   // path: url,
              //   name: "sample",
              // },
              theme: customTheme,
              loadImage: false,
              menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'icon', 'text', 'mask', 'filter'],
              initMenu: "draw",
              uiSize: {
                width: '100%',
                height: '100%',
              },
            }}
            cssMaxHeight={editorHeight}
            cssMaxWidth={700}
            selectionStyle={{
              cornerSize: 20,
              rotatingPointOffset: 70,
            }}
            usageStatistics={false}
          />
        </div>
      ) : (
        // PDF Editor
        <div
          ref={containerRef}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <div style={{ position: 'relative' }}>
            <canvas ref={canvasRef} />
            <canvas
              ref={overlayRef}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                cursor: activeEdit === 'highlight' || activeEdit === 'pen'
                  ? 'crosshair' : 'text',
                zIndex: 1,
              }}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onClick={handleCanvasClick}
            />
          </div>
          {/*  */}
          {annotations.map((ann, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                top: ann.drawY,
                left: ann.drawX,
                color: 'black',
                pointerEvents: 'none',
              }}
            >
              {ann.value}
            </div>
          ))}
          {inputData && (
            <input
              autoFocus
              ref={inputRef}
              value={inputData.value}
              onChange={(e) => setInputData({ ...inputData, value: e.target.value })}
              onKeyDown={handleInputKeyDown}
              style={{
                position: 'absolute',
                top: inputData.drawY,
                left: inputData.drawX,
                background: 'transparent',
                border: '1px dashed #888',
                fontSize: '16px',
                color: 'black',
                padding: '2px 4px',
              }}
            />
          )}
        </div>
      )}
      {openConfirm && (
        <Confirmation
          onCloseEditor={modalClose}
          onClose={setOpenConfirm}
        />
      )}
      {isloading && (
        <div
          className="loader"
          style={{
            position: "absolute",
            overflow: "hidden",
            backgroundColor: "#1e1e1e80",
          }}
        >
          <div align="center">
            <div className="loader-container">
              <div>
                <div>
                  <span className="loader-brand">HUBCHART</span>
                </div>
                <div className="loader-message">
                  <span>Please wait...</span>
                  <Spinner size={5} color={"#fbba09"} loading={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Confirmation = ({ onCloseEditor, onClose = () => {} }) => {
  return (
    <div className="assignment-notify-container">
      <div className="attention-notify-box" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h6>Close and remove changes ?</h6>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button btn-sm"
              style={{ marginRight: "10px" }}
              className="btn btn-danger"
              onClick={() => onCloseEditor()}
            >
              Close editor
            </button>
            <button 
              type="button btn-sm" 
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileEditor;
